import { types } from './actions';

const initialState = {
  isManagedIntegrationsCreateEditDrawerOpen: false,
  isEditing: false,
  managedIntegrationUuid: null,
  isSuperUser: null,
};

const reducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.MANAGED_INTEGRATIONS_CREATE_OR_EDIT_DRAWER_OPEN:
      return {
        ...state,
        isManagedIntegrationsCreateEditDrawerOpen: true,
        isSuperUser: payload.isSuperUser ?? null,
      };
    case types.MANAGED_INTEGRATIONS_DRAWER_CREATE_OR_EDIT_CLOSE:
      return {
        ...state,
        isManagedIntegrationsCreateEditDrawerOpen: false,
        managedIntegrationUuid: null,
        isEditing: false,
      };
    case types.MANAGED_INTEGRATIONS_DRAWER_EDIT_INTEGRATION:
      return {
        ...state,
        isManagedIntegrationsCreateEditDrawerOpen: true,
        isEditing: true,
        managedIntegrationUuid: payload.managedIntegrationUuid,
      };
    default:
      return state;
  }
};

export default reducer;

const getScope = (state) =>
  state.modules.common.drawers.managedIntegrationCreateEditDrawer;

export const isManagedIntegrationsCreateEditDrawerOpen = (state) =>
  getScope(state).isManagedIntegrationsCreateEditDrawerOpen;

export const isEditingManagedIntegration = (state) => getScope(state).isEditing;

export const getManagedIntegrationUuid = (state) =>
  getScope(state).managedIntegrationUuid;

export const getIsSuperUser = (state) => getScope(state).isSuperUser;
